import {Card, Col, Container, Row} from "react-bootstrap";
import ImgPic from "./assets/images/pic.png";
import {FaEnvelope, FaPhone} from "react-icons/fa";
import React from "react";
import {Link} from "react-router-dom";

const Header = () => {
    return (
        <>


            <Container>
                <Row className="justify-content-center div-style">
                    <Col md={8} lg={6} xl={5}>
                        <Card className="text-center p-4 shadow-sm card-hover">
                            <Link to="/">
                                <Card.Img
                                    variant="top"
                                    src={ImgPic}
                                    className="rounded-circle mx-auto img-fluid"
                                    style={{width: "250px"}}
                                    alt="Michaela Diener"
                                />
                            </Link>
                            <Card.Body>
                                <Link to="/" className="text-decoration-none text-color">
                                    <Card.Title>Michaela Diener</Card.Title>
                                    <Card.Text className="text-color">
                                        Systemische und Psychoanalytische Beratung<br/>
                                        in Apolda
                                    </Card.Text>
                                </Link>
                                <div className="d-flex justify-content-center mb-4">
                                    <a href="mailto:info@spb-apolda.de" className="btn btn-clr btn-sm mx-2">
                                        <FaEnvelope/> <span className="d-none d-sm-block">info@spb-apolda.de</span>
                                        <span className="d-block d-sm-none">Email</span>
                                    </a>
                                    <a href="tel:015156155457" className="btn btn-clr btn-sm mx-2">
                                        <FaPhone/> <span className="d-none d-sm-block">0151 / 56155457</span>
                                        <span className="d-block d-sm-none">Telefon</span>
                                    </a>
                                </div>

                                <div className="text-start mb-4">
                                    Mein Wunsch, etwas in der Tiefe zu verstehen, führte mich zunächst zur systemischen
                                    Beratung (DGsP). Um die Ressourcenarbeit und Lösungsorientierung nachhaltiger zu
                                    verankern, Emotionen und Affekte einzuordnen, erweiterte ich mein Verständnis für
                                    das Gewordensein eines Menschen und erlangte innerhalb der psychoanalytischen
                                    Beratung (postgradual) die notwendige Grundhaltung im Umgang mit inneren Konflikten.
                                </div>


                                <div className="text-end">
                                    Schreiben Sie mir eine E-Mail oder<br/>
                                    sprechen Sie auf meinen Anrufbeantworter.<br/>
                                    <br/>
                                    Ich werde mich umgehend bei Ihnen melden!
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
export default Header;
